import PropTypes from 'prop-types';
import React from 'react';
import autoBind from 'react-autobind';
import {withTranslation} from 'react-i18next';
import Styled from 'styled-components';

import infoIcon from '@/public/icons/info-icon-lined.svg';
import {colorPalette} from '@/themes/darkmode';

class InfoTooltip extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        t: PropTypes.func,
        overlayPosition: PropTypes.string, // "bottomRight", "bottomLeft"
        className: PropTypes.string,
        children: PropTypes.any,
        onClosed: PropTypes.func,
    };

    state = {
        showTooltip: false,
    };

    constructor(props) {
        super(props);
        autoBind(this);
        this.ref = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('click', this.handleDocumentClick);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleDocumentClick);
    }

    render() {
        const state = this.state;
        const props = this.props;
        const { t } = this.props;

        return (
            <div className={`info-tooltip ${props.className ?? ''}`} ref={this.ref}>
                <button className="info-tooltip-button" onClick={this.toggleOverlay}>{t(['Info', 'global.info'])}</button>
                {(state.showTooltip &&
                    <div className={`info-tooltip-overlay animate__animated animate__fadeIn animate__faster ${props.overlayPosition}`}>
                        <button className="info-tooltip-close-button" onClick={this.toggleOverlay}>&times;</button>

                        <h4>{props.title}</h4>
                        {props.children}
                    </div>
                )}
            </div>
        );
    }

    toggleOverlay() {
        this.setState(state => ({
            ...state,
            showTooltip: !state.showTooltip
        }));
    }

    handleDocumentClick(e) {
        if (this.state.showTooltip && !this.ref.current.contains(e.target)){
            this.setState(state => ({
                ...state,
                showTooltip: !state.showTooltip
            }));

            if(this.props.onClosed) {
                this.props.onClosed();
            }
        }
    }

    shouldComponentUpdate() {
        return true; // Layout component, has children
    }
}

//language=SCSS
InfoTooltip = Styled(InfoTooltip)`
& {
    position:absolute;
    right: 13px;
    bottom: 18px;
    display:inline-block;
    
    h4 {
        font-size:14px;
        font-weight:bold;
    }
    
    &:last-child {
        margin-right:0;
    }
    
    .info-tooltip-button {
        &, &:link, &:active {
            display:inline-block;
            background:url(${infoIcon}) no-repeat center;
            text-indent:-10000px;
            width:20px;
            height:20px;
            border-radius: 20px;
            color:transparent;
            text-transform: uppercase;
            font-size: 14px;
            border: none;
            outline: none;
            cursor:pointer;
        }

        &:hover, &focus {
            background-color:${colorPalette.thirdBackground};
        }
    }
    
    .info-tooltip-overlay {
        background:${colorPalette.thirdBackground};
        padding: 30px;
        margin-left: 20px;
        border-radius: 5px;
        z-index: 1051;
        position: absolute;
        width: 300px;
        left: 100%;
        top: -10px;
        box-shadow: 0 0 5px rgba(0,0,0,0.06);
        &:after {
            content: "";
            position: absolute;
            top: 10px;
            left: -10px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 10px 0;
            border-color: transparent ${colorPalette.thirdBackground} transparent transparent;
        }
        &.bottomRight {
            &:after {
                top:10px;
            }
        }
        &.bottomLeft {
            left: initial;
            right: 100%;
            margin-right: 12px;
            margin-left: 0;
            &:after {
                top: 10px;
                left: initial;
                right: -10px;
                border-width: 10px 0 10px 10px;
                border-color: transparent transparent transparent ${colorPalette.thirdBackground};
            }
        }
        > p:last-child {
            margin-bottom: 0;
        }
    }

    .info-tooltip-close-button {
        position:absolute;
        right:10px;
        top:5px;
        border:none;
        font-size: 20px;
        color:${colorPalette.frontColor};
        background:transparent;
    }
}`;

export default withTranslation()(InfoTooltip);
